import { Fragment, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { useTranslation } from 'react-i18next';

const ConfirmDialog = ({ isOpen, onClose, onConfirm, actionType }) => {
  const { t } = useTranslation();

  return (
    <Transition show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0">
          <div className="fixed inset-0 bg-black/25" />
        </Transition.Child>
        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0 scale-95" enterTo="opacity-100 scale-100" leave="ease-in duration-200" leaveFrom="opacity-100 scale-100" leaveTo="opacity-0 scale-95">
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-lg bg-white p-6 shadow-xl transition-all">
                <Dialog.Title className="text-lg font-semibold leading-6 text-black">{actionType.title}</Dialog.Title>
                <div className="mt-3">
                  <p className="text-sm text-gray-500">{actionType.text}</p>
                </div>
                <div className="mt-6 flex justify-end gap-3">
                  <button type="button" className="border rounded-md px-3 py-2 text-sm font-semibold text-black hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-500" onClick={onClose}>Cancel</button>
                  <button type="button" className="rounded-md px-3 py-2 text-sm font-semibold bg-black text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-black"
                    onClick={() => { onConfirm(); onClose(); }}>{t("confirm")}
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
};

const useConfirmation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [actionType, setActionType] = useState({});
  const [onConfirm, setOnConfirm] = useState(() => () => { });

  const open = (action, confirmCallback) => {
    setActionType(action);
    setOnConfirm(() => confirmCallback);
    setIsOpen(true);
  };

  const close = () => setIsOpen(false);

  return { open, ConfirmComponent: <ConfirmDialog isOpen={isOpen} onClose={close} onConfirm={onConfirm} actionType={actionType} /> };
};

export default useConfirmation;
